export default "/dist/files/photoCompetition.333608ad501ebf1f58e6f50c04aa3c5c.svg";